import { makeAutoObservable } from 'mobx';

import type { DashboardService } from '../api/DashboardService';
import type { FormationOption, SectionOption, StratUnitOption } from '../api/IDashboardService';

import { SortedOptionsStore } from './sorted-options.store';

export type TIntervalOptionsStatus = 'initial' | 'loading' | 'ready' | 'failed';

export class IntervalOptionsStore {
  status: TIntervalOptionsStatus = 'initial';

  formationsOptionsStore: SortedOptionsStore<FormationOption> = new SortedOptionsStore<FormationOption>();

  stratUnitsOptionsStore: SortedOptionsStore<StratUnitOption> = new SortedOptionsStore<StratUnitOption>();

  sectionsOptionsStore: SortedOptionsStore<SectionOption> = new SortedOptionsStore<SectionOption>();

  constructor(private dashboardService: DashboardService) {
    makeAutoObservable(this);
  }

  get formationsOptions() {
    return this.formationsOptionsStore.items;
  }

  get stratUnitsOptions() {
    return this.stratUnitsOptionsStore.items;
  }

  get sectionsOptions() {
    return this.sectionsOptionsStore.items;
  }

  setStatus(status: TIntervalOptionsStatus) {
    this.status = status;
  }

  load() {
    if (this.status === 'ready' || this.status === 'loading') {
      return Promise.resolve();
    }
    this.setStatus('loading');
    return Promise.all([
      this.dashboardService.getFormationsOptions(),
      this.dashboardService.getStratUnitsOptions(),
      this.dashboardService.getSectionsOptions(),
    ])
      .then(([formationsOptions, stratUnitsOptions, sectionsOptions]) => {
        this.formationsOptionsStore.setItems(formationsOptions);
        this.stratUnitsOptionsStore.setItems(stratUnitsOptions);
        this.sectionsOptionsStore.setItems(sectionsOptions);
        this.setStatus('ready');
      })
      .catch((err) => {
        console.error('Failed to fetch interval options', err);
        this.setStatus('failed');
      });
  }
}
